import React from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";

//styles
import { useStyles } from "./styles";

//types
import { SubAffDealHistoryItem } from "../../../../../store/admin/subAffDealsV2";

interface ISubAffDealHistoryDescriptionProps {
  data: any;
}

const SubAffDealHistoryDescription: React.FC<ISubAffDealHistoryDescriptionProps> = ({ data }) => {
  const { t } = useTranslation();
  const styles = useStyles();

  const change: SubAffDealHistoryItem['subAffiliateDealBindingChanges'] = data?.subAffiliateDealBindingChanges;

  if (!change) {
    return null;
  }

  return (
    <Typography className={styles.text} variant="body2" component="p">
      {t("admin.partners.subaffiliate_deal.history.first_description")}{" "}
      <b>{change.subAffiliateDealId} - {change.subAffiliateDealName}</b>,{" "}
      {t("admin.partners.subaffiliate_deal.history.second_description")}{" "}
      <b>{change.date || '—'}</b>,{" "}
      {t("admin.partners.subaffiliate_deal.history.third_description")}{" "}
      <b>{change.createdByUsername || '—'}</b>
    </Typography>
  );
};

export default SubAffDealHistoryDescription;
